import axios from "axios";
import { notify } from "./notify";
import { persistor } from "../store";
import { reactBackendUrl } from "../utils";

const backendURL = reactBackendUrl;

////////////////////////AUTH - Action Creator //////////////////////////

export const login = (data) => {
  return {
    type: "LOGIN",
    payload: data,
  };
};

export const logout = () => {
  return {
    type: "LOGOUT",
    payload: null,
  };
};

export const userUpdate = (data) => {
  return {
    type: "UPDATE_USER",
    payload: data,
  };
};

export const setForgotEmailAndToken = (data) => {
  return {
    type: "SET_FORGOT_EMAIL_AND_TOKEN",
    payload: data,
  };
};

//////////////////////// AUth - Actions //////////////////////////

export const loggingIn = async (data) => {
  try {
    const response = await axios.post(`${backendURL}user/login`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    // console.log(response);
    if (response.status === 200) {
      notify(response.data.message, "success");
      return response.data;
    }
  } catch (err) {
    if (err.response) {
      notify(
        Array.isArray(err.response?.data?.message)
          ? err.response?.data?.message[0]
          : err.response?.data?.message
      );
    } else {
      notify(err.message);
    }
  }
};

//////////////////////// -------- Flight Trader Api --------- //////////////////////////

export const fetchLiveTrackingData = async (value) => {
  try {
    const response = await fetch(
      `https://fr24api.flightradar24.com/api/flights?flights=${value}?apikey=pI7zGMVGGT3io1YeXaXDkDtaGvlGd1g3sqYfOdPu99s1OUZ0nz`
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error("Failed to fetch live tracking data");
    }
  } catch (error) {
    console.error("Error fetching live tracking data:", error);
    return null;
  }
};

//////////////////////// -------- Custom Actions --------- //////////////////////////

export const customAction = async (
  url,
  title,
  mode,
  data,
  token,
  multipart = false,
  showNotify = true
) => {
  switch (mode) {
    case "post":
      try {
        const response = await axios.post(`${backendURL}${url}`, data, {
          headers: {
            "Content-Type": multipart
              ? "multipart/form-data"
              : "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(`${title} Response", ${response}`);
        // console.log(response);
        if (response) {
          if (
            title != "Logout" &&
            title !== "Change password" &&
            (response.status === 200 ||
              response.status === 201 ||
              response.status === "True")
          ) {
            response?.data?.message &&
              showNotify &&
              notify(`${response?.data?.message}`, "success");
            showNotify &&
              !response?.data?.message &&
              title &&
              notify(`${title} created successfully`, "success");
          } else {
            showNotify && notify(response.data.message, "success");
          }
          return response.data;
        }
      } catch (err) {
        // console.log(err);
        if (err.response) {
          showNotify &&
            notify(
              Array.isArray(err.response?.data?.message)
                ? err.response?.data?.message[0]
                : err.response?.data?.message
            );
        } else {
          showNotify && notify(err.message);
        }
        return null;
      }
      break;
    case "put":
      try {
        const response = await axios.put(`${backendURL}${url}`, data, {
          headers: {
            "Content-Type": multipart
              ? "multipart/form-data"
              : "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(`${title} Response", ${response}`);
        // console.log(response);
        if (response.status === 200) {
          if (response.data) {
            showNotify && notify(response.data.message, "success");
          } else {
            showNotify && notify(response.data.message);
          }
          return response.data;
        }
      } catch (err) {
        // console.log("Error", err);
        if (err.response) {
          notify(
            Array.isArray(err.response?.data?.message)
              ? err.response?.data?.message[0]
              : err.response?.data?.message
          );
        } else {
          notify(err.message);
        }
      }
      break;
    case "patch":
      try {
        const response = await axios.patch(`${backendURL}${url}`, data, {
          headers: {
            "Content-Type": multipart
              ? "multipart/form-data"
              : "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(`${title} Response", ${response}`);
        // console.log(response);
        if (response.status === 200) {
          if (response.data) {
            showNotify && notify(response.data.message, "success");
          } else {
            showNotify && notify(response.data.message);
          }
          return response.data;
        }
      } catch (err) {
        // console.log("Error", err);
        if (err.response) {
          notify(
            Array.isArray(err.response?.data?.message)
              ? err.response?.data?.message[0]
              : err.response?.data?.message
          );
        } else {
          notify(err.message);
        }
      }
      break;
    case "delete":
      try {
        const response = await axios.delete(`${backendURL}${url}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(`${title} Response", ${response}`);
        // console.log(response);

        if (response.status === 204) {
          notify(`${title} deleted successfully`, "success");
          return response;
        } else {
          notify(response.data.message);
          return response;
        }
      } catch (err) {
        // console.log("Error", err);
        if (err.response) {
          notify(
            Array.isArray(err.response?.data?.message)
              ? err.response?.data?.message[0]
              : err.response?.data?.message
          );
        } else {
          notify(err.message);
        }
      }
      break;
    case "fetch":
      try {
        const response = await axios.get(`${backendURL}${url}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        // console.log(`${title} Response", ${response}`);
        if (response.data) {
          return response.data;
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          // console.log("@@ in", err.message);
          // notify("Token expired, Please login again");
          await persistor.purge();
          window.location.href = "/";
        }
        // console.log("@@", err);
      }
      break;
    default:
      break;
  }
};
